export default "__VITE_ASSET__DlaLsX6h__"